<template>
  <SidebarComponent />

  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Questionari Manuali</h1>

          <div class="filters">
            <select v-model="selectedStepKey" class="text-input" @change="applyCombinedFilter">
              <option value="">Step: tutti</option>
              <option value="questionario">questionario</option>
              <option value="feedback_programmi">feedback_programmi</option>
              <option value="check_finale">check_finale</option>
            </select>

            <select v-model="selectedAdmin" class="text-input" @change="applyCombinedFilter">
              <option value="">Stato admin: tutti</option>
              <option value="needs_update">Richiesto aggiornamento</option>
              <option value="updated">Aggiornato</option>
              <option value="todo">Da lavorare</option>
              <option value="none">—</option>
            </select>

            <select v-model="selectedValutazione" class="text-input" @change="applyCombinedFilter">
              <option value="">Valutazione: tutte</option>
              <option value="1-2">1–2</option>
              <option value="3">3</option>
              <option value="4-5">4–5</option>
            </select>

            <select v-model="selectedStudio" class="text-input" @change="applyCombinedFilter">
              <option value="">Studio: tutti</option>
              <option v-for="studio in studioOptions" :key="studio" :value="studio">
                {{ studio }}
              </option>
            </select>

            <input
              type="date"
              v-model="dateFrom"
              class="text-input"
              aria-label="Data da"
              @change="applyCombinedFilter"
            />

            <input
              type="date"
              v-model="dateTo"
              class="text-input"
              aria-label="Data a"
              @change="applyCombinedFilter"
            />

            <button class="btn" @click="resetFilters">Reset</button>
            <button class="btn" @click="exportCsv" :disabled="isLoading || !savedQuestionari.length">
              Export csv
            </button>
            <button class="btn" @click="toggleShowStopped">
              {{ showStopped ? 'Mostra non stop' : 'Mostra stop' }}
            </button>
          </div>
        </div>

        <div v-if="isLoading" class="loader"><h4>Caricamento…</h4></div>

        <template v-else>
          <div v-if="filteredQuestionari.length" class="tickets">
            <table>
              <thead>
                <tr>
                  <th class="col-idx">#</th>
                  <th class="col-azione">Azioni</th>
                  <th class="col-admin">Stato admin</th>
                  <th class="col-note">Note</th>
                  <th class="col-data">Data</th>
                  <th class="col-email">Utente (email)</th>
                  <th class="col-acquisto-flag">Acquisto</th>
                  <th class="col-acquisto">Ultimo acquisto</th>
                  <th class="col-acquisto-data">Data acquisto</th>
                  <th class="col-studio">Studio</th>
                  <th class="col-step">Step</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(q, i) in filteredQuestionari"
                  :key="q.id"
                  :class="feedbackColor(q)"
                >
                  <td class="mono">{{ i + 1 }}</td>

                  <td>
                    <button
                      class="profile-button"
                      @click="handleQuestionarioClick(q)"
                      :title="questionarioLinkLabel(q)"
                    >
                      <span class="material-icons">article</span>
                    </button>
                    <button class="profile-button" @click="gotoUser(q.uid)" :disabled="!q.uid">
                      <span class="material-icons">visibility</span>
                    </button>
                    <button
                      type="button"
                      class="stop-btn"
                      @click="markStop(q)"
                      :disabled="q._savingStop"
                      :title="q.isStopped ? 'Rimuovi stop' : 'STOP'"
                      :aria-label="q.isStopped ? 'Rimuovi stop' : 'STOP'"
                    >
                      <span class="material-icons" aria-hidden="true">
                        {{ q.isStopped ? 'play_arrow' : 'stop' }}
                      </span>
                    </button>
                  </td>

                  <td class="admin-col">
                    <div class="chips-line">
                      <span class="admin-chip" :class="adminChipClass(q.adminStatus)">
                        {{ adminLabel(q.adminStatus) }}
                      </span>
                    </div>
                    <small v-if="(q.adminNote||'').length" class="muted">
                      Nota: “{{ q.adminNote }}”
                    </small>
                  </td>

                  <td>
                    <input
                      class="note-input"
                      :placeholder="'—'"
                      v-model="staffNoteEdits[keyFor(q)]"
                      @blur="saveStaffNote(q)"
                      @keyup.enter="saveStaffNote(q)"
                      :disabled="q._savingNote"
                    />
                    <small v-if="q._savingNote" class="muted">salvo…</small>
                    <small v-else-if="saveStatus[keyFor(q)]==='ok'" class="muted">salvato ✓</small>
                    <small v-else-if="saveStatus[keyFor(q)]==='err'" class="muted">errore ✗</small>
                  </td>

                  <td>{{ formatDateTime(q.createdAt) }}</td>
                  <td class="mono">{{ userEmails[q.uid] || '—' }}</td>
                  <td>
                    <span class="purchase-chip" :class="purchaseChipClass(q.uid)">
                      {{ purchaseChipLabel(q.uid) }}
                    </span>
                  </td>
                  <td
                    :title="latestOrderProductLabel(q.uid)"
                    :class="latestOrderProductClass(q.uid)"
                  >
                    {{ latestOrderProductLabel(q.uid) }}
                  </td>
                  <td>{{ latestOrderDateLabel(q.uid) }}</td>
                  <td>{{ userStudios[q.uid] || '—' }}</td>
                  <td class="mono">
                    <div class="step-cell">
                      <span>{{ q.stepKey || '—' }}</span>
                      <span v-if="stepCloneLabel(q)" class="step-tag">· {{ stepCloneLabel(q) }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="muted">Nessun questionario manuale.</div>
        </template>
      </div>
    </div>
  </div>

  <div v-if="showModal" class="modal">
    <div class="dialog">
      <div class="modal-head">
        <h3>Risposte questionario</h3>
        <div class="head-actions">
          <input v-model.trim="modalSearch" class="text-input small" placeholder="Filtra campi…" />
          <button class="btn tiny" @click="closeModal">Chiudi</button>
        </div>
      </div>

      <div class="modal-scroll">
        <div class="meta">
          <div><strong>Email:</strong> <span class="mono">{{ userEmails[activeRow?.uid] || '—' }}</span></div>
          <div><strong>Prodotto:</strong> {{ activeRow?.productName || '—' }}</div>
          <div class="meta-step">
            <strong>Step:</strong>
            <span>{{ activeRow?.stepKey || '—' }}</span>
            <span v-if="stepCloneLabel(activeRow)" class="step-tag">· {{ stepCloneLabel(activeRow) }}</span>
          </div>
          <div><strong>Data:</strong> {{ formatDateTime(activeRow?.createdAt) }}</div>
          <div><strong>Sequenza:</strong>
            <template v-if="activeRow?.sequenceIndex != null">
              {{ activeRow.sequenceIndex }}<template v-if="activeRow?.sequenceTotal">/{{ activeRow.sequenceTotal }}</template>
            </template>
            <template v-else>—</template>
          </div>
          <div><strong>Stato admin:</strong> {{ adminLabel(activeRow?.adminStatus) }}</div>
          <div v-if="activeRow?.adminNote"><strong>Nota:</strong> “{{ activeRow.adminNote }}”</div>
        </div>

        <div class="answers">
          <div v-if="modalLoading" class="data-state">Caricamento dati…</div>
          <div v-else-if="modalBundleError" class="data-state error">{{ modalBundleError }}</div>
          <template v-else>
            <div v-if="modalSections.length" class="modal-sections">
              <section v-for="section in modalSections" :key="section.key" class="modal-section">
                <header class="modal-section__head">
                  <div>
                    <h4>{{ section.title }}</h4>
                    <p v-if="section.subtitle" class="modal-section__subtitle">{{ section.subtitle }}</p>
                  </div>
                  <div v-if="section.meta" class="modal-section__meta">{{ section.meta }}</div>
                </header>
                <div v-if="section.groups.length" class="modal-section__body">
                  <div
                    v-for="group in section.groups"
                    :key="group.key || group.title || group.rootLabel"
                    class="modal-group"
                  >
                    <h5 v-if="group.title" class="modal-group__title">{{ group.title }}</h5>
                    <div
                      v-for="entry in group.entries"
                      :key="entry.key"
                      class="modal-row"
                      :class="{ multiline: entry.multiline }"
                    >
                      <div class="modal-row__key mono">{{ entry.labelInGroup }}</div>
                      <div class="modal-row__value">
                        <pre v-if="entry.multiline">{{ entry.display }}</pre>
                        <span v-else>{{ entry.display }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="data-state muted">Nessun campo corrisponde al filtro.</div>
              </section>
            </div>
            <div v-else class="data-state muted">Nessun campo corrisponde al filtro.</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarComponent from '../SidebarComponent.vue';
import {
  getFirestore,
  collection,
  query,
  onSnapshot,
  doc,
  getDoc,
  updateDoc,
  getDocs,
  where
} from 'firebase/firestore';
import {
  flattenAnswers,
  prettifyKey,
  buildQuestionarioSections,
  buildCheckFinaleSections,
} from '../../lib/questionarioDisplay.js';

const toDateSafe = (value) => {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
  if (value?.toDate) {
    const d = value.toDate();
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

export default {
  name: 'QuestionariManuali',
  components: { SidebarComponent },

  data() {
    return {
      savedQuestionari: [],
      rawFilteredData: [],
      filteredQuestionari: [],
      isLoading: true,

      selectedStepKey: '',
      selectedAdmin: '',
      selectedValutazione: '',
      selectedStudio: '',
      dateFrom: '',
      dateTo: '',
      showStopped: false,

      userEmails: {},
      userStudios: {},
      fetchingUids: new Set(),
      latestOrderByEmail: {},
      fetchingOrderEmails: new Set(),

      showModal: false,
      activeRow: null,
      modalSearch: '',
      modalBundle: null,
      modalBundleError: '',
      modalLoading: false,
      bundleCache: {},

      staffNoteEdits: {},
      saveStatus: {},

      unsubscribeManualQuestionari: null,
    };
  },

  computed: {
    modalSections() {
      if (!this.activeRow) return [];
      const sections = [];
      const search = this.modalSearch;
      const bundle = this.modalBundle || {};
      const activeId = this.activeRow?.id;

      const addSection = (key, title, subtitle, info, answers, typeKey) => {
        const groups = this.buildSectionGroups(typeKey, answers, search);
        if (!groups.length) return;
        sections.push({
          key,
          title,
          subtitle: subtitle || '',
          meta: info?.updatedAt
            ? `Aggiornato: ${this.formatDateTime(info.updatedAt)}`
            : info?.createdAt
            ? `Creato: ${this.formatDateTime(info.createdAt)}`
            : '',
          groups,
        });
      };

      if (bundle.questionario) {
        addSection(
          'questionario',
          'Questionario Programmi',
          bundle.questionario.templateLabel,
          bundle.questionario,
          bundle.questionario.answers,
          'questionario'
        );
      }

      if (bundle.checkFinale) {
        addSection(
          'check_finale',
          'Check Finale Programmi',
          bundle.checkFinale.templateLabel,
          bundle.checkFinale,
          bundle.checkFinale.answers,
          'check_finale'
        );
      }

      const currentIsKnown =
        (bundle.questionario && bundle.questionario.docId === activeId) ||
        (bundle.checkFinale && bundle.checkFinale.docId === activeId);

      if (!currentIsKnown) {
        const createdAt = this.activeRow?.createdAt ? new Date(this.activeRow.createdAt) : null;
        const updatedAt = this.activeRow?.updatedAt ? new Date(this.activeRow.updatedAt) : null;
        addSection(
          'current',
          this.sectionTitle(this.activeRow),
          this.sectionSubtitle(this.activeRow),
          { createdAt, updatedAt },
          this.activeRow.answers || {},
          (this.activeRow?.stepKey || '').toLowerCase()
        );
      }

      return sections;
    },

    studioOptions() {
      const opts = new Set();
      Object.values(this.userStudios || {}).forEach((studio) => {
        if (studio && studio !== '—') {
          opts.add(studio);
        }
      });
      return Array.from(opts).sort((a, b) => a.localeCompare(b));
    }
  },

  mounted() {
    this.listenManualQuestionari();
  },

  beforeUnmount() {
    if (typeof this.unsubscribeManualQuestionari === 'function') {
      this.unsubscribeManualQuestionari();
      this.unsubscribeManualQuestionari = null;
    }
  },

  methods: {
    keyFor(row) {
      return `manual__${row.id}`;
    },

    normalizeEmail(value) {
      const trimmed = (value || '').toString().trim();
      return trimmed ? trimmed.toLowerCase() : '';
    },

    normalizePaymentMethod(value) {
      return (value || '').toString().trim().toLowerCase().replace(/[\s-]+/g, '_');
    },

    latestOrderEntry(uid) {
      const email = (this.userEmails[uid] || '').toString().trim();
      if (!email || email === '—') return null;
      const key = this.normalizeEmail(email);
      return this.latestOrderByEmail[key] || null;
    },

    purchaseChipLabel(uid) {
      const email = (this.userEmails[uid] || '').toString().trim();
      if (!email || email === '—') return '—';
      const key = this.normalizeEmail(email);
      if (this.fetchingOrderEmails.has(key)) return '…';
      if (!(key in this.latestOrderByEmail)) return '…';
      const entry = this.latestOrderByEmail[key];
      if (!entry || !entry.order) return 'No';
      if (this.isCoachingDayOnlineOrder(entry.order)) return 'No';
      return 'Si';
    },

    purchaseChipClass(uid) {
      const email = (this.userEmails[uid] || '').toString().trim();
      if (!email || email === '—') return 'purchase-chip--muted';
      const key = this.normalizeEmail(email);
      if (this.fetchingOrderEmails.has(key)) return 'purchase-chip--pending';
      if (!(key in this.latestOrderByEmail)) return 'purchase-chip--pending';
      const entry = this.latestOrderByEmail[key];
      if (!entry || !entry.order) return 'purchase-chip--no';
      if (this.isCoachingDayOnlineOrder(entry.order)) return 'purchase-chip--no';
      return 'purchase-chip--yes';
    },

    latestOrderProductLabel(uid) {
      const entry = this.latestOrderEntry(uid);
      if (!entry?.order) return '—';
      return this.resolveOrderProductLabel(entry.order) || '—';
    },

    latestOrderProductClass(uid) {
      const entry = this.latestOrderEntry(uid);
      if (!entry?.order) return '';
      return this.isCoachingDayOnlineOrder(entry.order) ? 'purchase-product--coaching' : '';
    },

    latestOrderDateLabel(uid) {
      const entry = this.latestOrderEntry(uid);
      if (!entry?.date) return '—';
      return this.formatDateOnly(entry.date);
    },

    normalizeProductName(value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
    },

    isCoachingDayOnlineOrder(order) {
      if (!order || typeof order !== 'object') return false;
      const target = 'coaching day online';
      const names = [];

      if (Array.isArray(order.products)) {
        order.products.forEach((item) => {
          const name = item?.name || item?.title || item?.productName || item?.sku;
          const normalized = this.normalizeProductName(name);
          if (normalized) names.push(normalized);
        });
      }

      if (!names.length) {
        const fallback = order.productName || order.orderName || order.orderTitle || order.title || order.name;
        const normalized = this.normalizeProductName(fallback);
        if (normalized) names.push(normalized);
      }

      if (!names.length) return false;
      return names.every((name) => name === target);
    },

    isCsenOrder(order) {
      if (!order || typeof order !== 'object') return false;
      const targets = new Set(['1 anno csen', '1annocsen']);
      const names = [];

      if (Array.isArray(order.products)) {
        order.products.forEach((item) => {
          const name = item?.name || item?.title || item?.productName || item?.sku;
          const normalized = this.normalizeProductName(name);
          if (normalized) names.push(normalized);
        });
      }

      if (!names.length) {
        const fallback = order.productName || order.orderName || order.orderTitle || order.title || order.name;
        const normalized = this.normalizeProductName(fallback);
        if (normalized) names.push(normalized);
      }

      if (!names.length) return false;
      return names.every((name) => {
        for (const target of targets) {
          if (name.includes(target)) return true;
        }
        return false;
      });
    },

    manualRowGroupKey(row) {
      if (!row) return '';
      const rawKey =
        row.questionarioKey ||
        row.questionarioUid ||
        row.questionarioDocId ||
        row.rawData?.questionarioKey ||
        row.rawData?.questionarioUid ||
        row.rawData?.questionarioDocId ||
        '';
      const rawStep = (row.stepKey || row.rawData?.stepKey || '').toString().trim().toLowerCase();
      const rawType = (row.type || row.rawData?.type || '').toString().trim().toLowerCase();
      let stepKey = rawStep;
      if (!stepKey) {
        if (rawType.includes('check_finale')) stepKey = 'check_finale';
        else if (rawType.includes('feedback_programmi')) stepKey = 'feedback_programmi';
        else if (rawType.includes('questionario')) stepKey = 'questionario';
        else stepKey = rawType;
      }
      const uidKey = (row.uid || row.rawData?.uid || '').toString().trim();
      const fallbackKey = uidKey && stepKey ? `${uidKey}__${stepKey}` : '';

      const normalizedRaw = String(rawKey || '').trim();
      const normalizedId = String(row.id || '').trim();
      if (normalizedRaw && normalizedRaw !== normalizedId) {
        return stepKey ? `${stepKey}__${normalizedRaw}` : normalizedRaw;
      }
      if (fallbackKey) return fallbackKey;
      if (normalizedRaw) return stepKey ? `${stepKey}__${normalizedRaw}` : normalizedRaw;
      return row.id || '';
    },

    dedupeManualRows(rows = []) {
      const map = new Map();
      rows.forEach((row) => {
        const key = this.manualRowGroupKey(row);
        if (!key) return;
        const current = map.get(key);
        if (!current) {
          map.set(key, row);
          return;
        }
        const currentTime = toDateSafe(current.updatedAt || current.createdAt)?.getTime() || 0;
        const nextTime = toDateSafe(row.updatedAt || row.createdAt)?.getTime() || 0;
        if (nextTime >= currentTime) {
          map.set(key, row);
        }
      });
      return Array.from(map.values());
    },

    resolveOrderProductLabel(order) {
      if (!order || typeof order !== 'object') return '';
      const names = [];
      const pushName = (value) => {
        const label = (value || '').toString().trim();
        if (label) names.push(label);
      };
      if (Array.isArray(order.products)) {
        order.products.forEach((item) => {
          pushName(item?.name || item?.title || item?.productName || item?.sku);
        });
      }
      const unique = Array.from(new Set(names));
      if (unique.length === 1) return unique[0];
      if (unique.length > 1) return `${unique[0]} +${unique.length - 1}`;
      pushName(order.productName || order.orderName || order.orderTitle || order.title || order.name);
      return names[0] || '';
    },

    parseOrderDate(order) {
      if (!order || typeof order !== 'object') return null;
      const candidates = [
        order.orderDate,
        order.order_date,
        order.createdAt,
        order.creationDate,
        order.importedAt,
        order.updatedAt,
        order.date,
        order.timestamp,
        order.completedAt,
      ];
      for (const value of candidates) {
        const date = this.toDate(value);
        if (date) return date;
      }
      return null;
    },

    toDate(value) {
      if (!value) return null;
      if (typeof value?.toDate === 'function') {
        try { return value.toDate(); } catch { return null; }
      }
      if (typeof value === 'object' && typeof value.seconds === 'number') {
        return new Date(value.seconds * 1000);
      }
      if (typeof value === 'number') {
        const d = new Date(value);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      if (typeof value === 'string') {
        const normalized = value.includes('T') ? value : value.replace(' ', 'T');
        const d = new Date(normalized);
        return Number.isNaN(d.getTime()) ? null : d;
      }
      return null;
    },

    isManualInstallmentPaid(inst) {
      if (!inst) return false;
      if (inst.paidAt) return true;
      return String(inst.status || '').trim().toLowerCase() === 'pagato';
    },

    hasPaidManualInstallments(plan = []) {
      if (!Array.isArray(plan)) return false;
      return plan.some((inst) => this.isManualInstallmentPaid(inst));
    },

    isManualInstallmentsOrder(order) {
      if (!order || typeof order !== 'object') return false;
      const method = this.normalizePaymentMethod(order.paymentMethod || order.payment_method);
      return method === 'rate_manuali' || Array.isArray(order.manualInstallments);
    },

    isOrderPaid(order) {
      if (!order || typeof order !== 'object') return false;
      if (order.paid === true || order.isPaid === true) return true;
      if (this.isManualInstallmentsOrder(order) && this.hasPaidManualInstallments(order.manualInstallments)) return true;

      const status = (order.status || order.orderStatus || order.state || '').toString().toLowerCase();
      const paymentStatus = (order.paymentStatus || order.payment_status || '').toString().toLowerCase();

      const paidStatuses = new Set([
        'pagato',
        'paid',
        'completed',
        'complete',
        'processing',
        'wc-completed',
        'wc-processing',
        'direct_purchase',
        'payment_completed',
        'completed_payment',
      ]);
      if (paidStatuses.has(status)) return true;
      if (status.startsWith('wc-') && (status.includes('completed') || status.includes('processing'))) return true;
      if (status.includes('direct') && status.includes('purchase')) return true;
      if (status.includes('payment') && status.includes('complete')) return true;

      const paidPaymentStatuses = new Set([
        'paid',
        'completed',
        'complete',
        'captured',
        'succeeded',
        'settled',
      ]);
      if (paidPaymentStatuses.has(paymentStatus)) return true;
      if (paymentStatus.includes('completed') || paymentStatus.includes('captured')) return true;

      return false;
    },

    async fetchOrdersByEmail(emails = []) {
      const normalizedSet = new Set();
      (emails || []).forEach((email) => {
        const key = this.normalizeEmail(email);
        if (!key) return;
        if (key in this.latestOrderByEmail) return;
        if (this.fetchingOrderEmails.has(key)) return;
        normalizedSet.add(key);
      });
      const normalized = Array.from(normalizedSet);

      if (!normalized.length) return;

      normalized.forEach((email) => this.fetchingOrderEmails.add(email));

      const db = getFirestore();
      const chunks = [];
      for (let i = 0; i < normalized.length; i += 10) {
        chunks.push(normalized.slice(i, i + 10));
      }

      try {
        for (const chunk of chunks) {
          const latestByEmail = {};
          chunk.forEach((email) => {
            latestByEmail[email] = null;
          });

          const applyOrdersSnap = (snap, field) => {
            snap.forEach((docSnap) => {
              const data = docSnap.data() || {};
              const orderEmail = this.normalizeEmail(data[field]);
              if (!orderEmail || !(orderEmail in latestByEmail)) return;
              if (!this.isOrderPaid(data)) return;
              if (this.isCsenOrder(data)) return;
              const date = this.parseOrderDate(data);
              const time = date ? date.getTime() : 0;
              const current = latestByEmail[orderEmail];
              if (!current || time >= current.time) {
                latestByEmail[orderEmail] = {
                  order: { id: docSnap.id, ...data },
                  date,
                  time,
                };
              }
            });
          };

          const snapUser = await getDocs(query(collection(db, 'orders'), where('userEmail', 'in', chunk)));
          applyOrdersSnap(snapUser, 'userEmail');

          const snapCustomer = await getDocs(query(collection(db, 'orders'), where('customerEmail', 'in', chunk)));
          applyOrdersSnap(snapCustomer, 'customerEmail');

          this.latestOrderByEmail = { ...this.latestOrderByEmail, ...latestByEmail };
        }
      } catch (error) {
        console.error('Errore nel recupero degli ordini:', error);
      } finally {
        normalized.forEach((email) => this.fetchingOrderEmails.delete(email));
      }
    },

    async markStop(row) {
      if (!row || row._savingStop) return;
      const nextStop = !row.isStopped;
      try {
        row._savingStop = true;
        const db = getFirestore();
        await updateDoc(doc(db, 'questionari', row.id), {
          stop: nextStop,
          isStopped: nextStop,
          adminUpdatedAt: new Date().toISOString()
        });
        row.isStopped = nextStop;
        if (row.rawData) {
          row.rawData.stop = nextStop;
          row.rawData.isStopped = nextStop;
        }
        this.applyCombinedFilter();
      } catch (error) {
        console.error('markStop error:', error);
        alert('Errore nel salvataggio dello STOP.');
      } finally {
        row._savingStop = false;
      }
    },

    toNullableInt(value) {
      if (value === undefined || value === null || value === '') return null;
      const num = Number(value);
      if (!Number.isFinite(num)) return null;
      const intVal = Math.round(num);
      return Number.isFinite(intVal) ? intVal : null;
    },

    isTruthyManualStandalone(value) {
      if (value === true) return true;
      if (value === 1) return true;
      if (value === '1') return true;
      if (typeof value === 'string') {
        const v = value.trim().toLowerCase();
        return v === 'true' || v === 'yes';
      }
      return false;
    },

    isManualQuestionarioPayload(payload) {
      if (!payload || payload.percorsoId) return false;
      if (this.isTruthyManualStandalone(payload.manualStandalone)) return true;

      const stepKey = String(payload.stepKey || '').trim().toLowerCase();
      const allowedStepKeys = new Set(['questionario', 'check_finale', 'feedback_programmi']);
      const typeKey = String(payload.type || '').trim().toLowerCase();
      const allowedTypes = new Set(['user_programmi_questionario', 'user_programmi_check_finale', 'feedback_programmi']);
      const hasAllowedStepKey = !!stepKey && allowedStepKeys.has(stepKey);
      const hasAllowedType = !!typeKey && allowedTypes.has(typeKey);
      if (!hasAllowedStepKey && !hasAllowedType) return false;

      const isZeroOrNull = (value) => {
        if (value == null) return true;
        const num = Number(value);
        return !Number.isNaN(num) && num === 0;
      };

      return (payload.sequenceGroupId == null)
        && isZeroOrNull(payload.sequenceIndex)
        && isZeroOrNull(payload.sequenceTotal)
        && isZeroOrNull(payload.stepIndex);
    },

    feedbackColor(q) {
      if (q.stepKey !== 'feedback_programmi') return '';
      const val = Number(q.answers?.valutazione);
      if ([1, 2].includes(val)) return 'fb-red';
      if (val === 3) return 'fb-orange';
      if ([4, 5].includes(val)) return 'fb-green';
      return '';
    },

    passValutazione(q) {
      if (!this.selectedValutazione) return true;
      const val = Number(q?.answers?.valutazione);
      if (Number.isNaN(val)) return false;
      if (this.selectedValutazione === '1-2') return val === 1 || val === 2;
      if (this.selectedValutazione === '3')   return val === 3;
      if (this.selectedValutazione === '4-5') return val === 4 || val === 5;
      return true;
    },

    buildSectionGroups(typeKey, answers, searchTerm) {
      if (!answers || typeof answers !== 'object') return [];
      const normalized = (typeKey || '').toLowerCase();
      if (normalized === 'questionario' || normalized === 'user_programmi_questionario') {
        return buildQuestionarioSections(answers, searchTerm).map((section) => ({
          key: section.key,
          title: section.title,
          entries: section.entries,
        }));
      }
      if (normalized === 'check_finale' || normalized === 'user_programmi_check_finale') {
        return buildCheckFinaleSections(answers, searchTerm).map((section) => ({
          key: section.key,
          title: section.title,
          entries: section.entries,
        }));
      }
      return this.buildFallbackSections(answers, searchTerm);
    },

    buildFallbackSections(answers, searchTerm) {
      const entries = flattenAnswers(answers || {});
      const needle = (searchTerm || '').trim().toLowerCase();
      const buckets = new Map();

      entries.forEach((entry) => {
        const haystack = `${entry.label} ${entry.display}`.toLowerCase();
        if (needle && !haystack.includes(needle)) return;
        const root = entry.root;
        if (!buckets.has(root)) {
          buckets.set(root, {
            key: root,
            title: prettifyKey(root),
            entries: [],
          });
        }
        buckets.get(root).entries.push(entry);
      });

      return Array.from(buckets.values()).map((group) => {
        group.entries.sort((a, b) => a.label.localeCompare(b.label));
        return group;
      });
    },

    listenManualQuestionari() {
      const db = getFirestore();
      // Filtra a monte: documenti non collegati a percorsi (manuali/legacy manuali)
      // Evita di ascoltare tutta la collection `questionari`.
      const qRef = query(collection(db, 'questionari'), where('percorsoId', '==', null));
      if (typeof this.unsubscribeManualQuestionari === 'function') {
        this.unsubscribeManualQuestionari();
        this.unsubscribeManualQuestionari = null;
      }
      this.unsubscribeManualQuestionari = onSnapshot(qRef, async (snap) => {
        const arr = snap.docs
          .map((d) => {
            const x = d.data() || {};
            if (!this.isManualQuestionarioPayload(x)) return null;
            return {
              id: d.id,
              uid: x.uid || null,
              percorsoId: null,
              stepIndex: this.toNullableInt(x.stepIndex),
              stepKey: x.stepKey || null,
              templateId: x.templateId || null,
              templateVersion: x.templateVersion ?? null,
              templateKey: x.templateKey || x.questionarioTemplateKey || null,
              templateLabel:
                x.templateLabel ||
                x.questionarioTemplateLabel ||
                x.questionarioTemplate ||
                null,
              productId: x.productId || null,
              productName: x.productName || null,
              programTitle: x.programTitle || null,
              programLabel: x.programLabel || null,
              plannedStartAt: x.plannedStartAt || null,
              expireAt: x.expireAt || null,
              stepName: x.stepName || null,
              sequenceGroupId: x.sequenceGroupId || null,
              sequenceIndex: this.toNullableInt(x.sequenceIndex),
              sequenceTotal: this.toNullableInt(x.sequenceTotal),
              questionarioUid: x.questionarioUid || null,
              questionarioDocId: x.questionarioDocId || null,
              questionarioKey: x.questionarioKey || null,
              createdAt: x.createdAt?.toDate ? x.createdAt.toDate() : (x.createdAt || null),
              updatedAt: x.updatedAt?.toDate ? x.updatedAt.toDate() : (x.updatedAt || null),
              answers: x.answers || {},
              type: x.type || null,
              staffNote: x.staffNote || '',
              adminStatus: x.adminStatus || 'none',
              adminNote: x.adminNote ?? null,
              manualStandalone: this.isTruthyManualStandalone(x.manualStandalone),
              percorsoIdValid: false,
              isStopped: x.stop === true || x.isStopped === true,
              rawData: { ...x },
              _savingNote: false,
              _savingStop: false,
            };
          })
          .filter(Boolean);

        const deduped = this.dedupeManualRows(arr).sort((a, b) => {
          const at = toDateSafe(a.createdAt)?.getTime() || 0;
          const bt = toDateSafe(b.createdAt)?.getTime() || 0;
          return at - bt;
        });

        this.initializeStaffNotes(deduped);

        const missingU = [];
        for (const r of deduped) {
          const u = r.uid;
          const hasEmail = !!this.userEmails[u];
          const hasStudio = this.userStudios[u] != null;
          if (u && (!hasEmail || !hasStudio) && !this.fetchingUids.has(u)) {
            missingU.push(u);
            this.fetchingUids.add(u);
          }
        }
        if (missingU.length) this.fetchUsersEmails(missingU);

        this.savedQuestionari = deduped;
        this.rawFilteredData = [...deduped];
        this.applyCombinedFilter();
        this.isLoading = false;
      });
    },

    initializeStaffNotes(rows) {
      const pending = {};
      rows.forEach((r) => {
        const k = this.keyFor(r);
        if (this.staffNoteEdits[k] == null) {
          pending[k] = r.staffNote || '';
        }
      });
      if (Object.keys(pending).length) {
        this.staffNoteEdits = { ...this.staffNoteEdits, ...pending };
      }
    },

    async fetchUsersEmails(uids) {
      const db = getFirestore();
      const chunks = [];
      for (let i = 0; i < uids.length; i += 10) chunks.push(uids.slice(i, i + 10));

      for (const ch of chunks) {
        const results = await Promise.all(ch.map(async (uid) => {
          try {
            const s = await getDoc(doc(db, 'users', uid));
            const d = s.exists() ? (s.data() || {}) : {};
            return {
              uid,
              email: d.email || d.userEmail || null,
              studio: d.studio || d.studioName || ''
            };
          } catch {
            return { uid, email: null, studio: '' };
          }
        }));
        const nextEmails = { ...this.userEmails };
        const nextStudios = { ...this.userStudios };
        const orderEmails = [];
        results.forEach(({ uid, email, studio }) => {
          const trimmedEmail = (email || '').toString().trim();
          nextEmails[uid] = trimmedEmail || '—';
          nextStudios[uid] = (studio || '').trim();
          if (trimmedEmail) orderEmails.push(trimmedEmail);
          this.fetchingUids.delete(uid);
        });
        this.userEmails = nextEmails;
        this.userStudios = nextStudios;
        this.applyCombinedFilter();
        if (orderEmails.length) {
          this.fetchOrdersByEmail(orderEmails);
        }
      }
    },

    resetFilters() {
      this.selectedStepKey = '';
      this.selectedAdmin = '';
      this.selectedValutazione = '';
      this.selectedStudio = '';
      this.dateFrom = '';
      this.dateTo = '';
      this.showStopped = false;
      this.applyCombinedFilter();
    },

    toggleShowStopped() {
      this.showStopped = !this.showStopped;
      this.applyCombinedFilter();
    },

    applyCombinedFilter() {
      const fromDateRaw = this.dateFrom ? new Date(`${this.dateFrom}T00:00:00`) : null;
      const toDateRaw = this.dateTo ? new Date(`${this.dateTo}T23:59:59.999`) : null;
      const fromDate = fromDateRaw && !Number.isNaN(fromDateRaw.getTime()) ? fromDateRaw : null;
      const toDate = toDateRaw && !Number.isNaN(toDateRaw.getTime()) ? toDateRaw : null;

      const passAdmin = (q) => {
        const status = q.adminStatus || 'none';
        if (!this.selectedAdmin) return true;
        if (this.selectedAdmin === 'needs_update') return status === 'needs_update';
        if (this.selectedAdmin === 'updated') return status === 'updated';
        if (this.selectedAdmin === 'todo') {
          return status === 'none' || status === 'updated' || status === 'needs_update';
        }
        if (this.selectedAdmin === 'none') return status === 'none';
        return true;
      };
      const passStep = (q) => !this.selectedStepKey || q.stepKey === this.selectedStepKey;
      const passStudio = (q) => {
        if (!this.selectedStudio) return true;
        return (this.userStudios[q.uid] || '') === this.selectedStudio;
      };
      const passDate = (q) => {
        if (!fromDate && !toDate) return true;
        const created = toDateSafe(q.createdAt);
        if (!created) return false;
        if (fromDate && created < fromDate) return false;
        if (toDate && created > toDate) return false;
        return true;
      };
      const passStopped = (q) => {
        if (this.showStopped) return !!q.isStopped;
        return !q.isStopped;
      };

      this.filteredQuestionari = (this.rawFilteredData || []).filter(
        q => passAdmin(q)
          && passStep(q)
          && this.passValutazione(q)
          && passDate(q)
          && passStudio(q)
          && passStopped(q)
      );
    },

    async saveStaffNote(row) {
      const k = this.keyFor(row);
      const note = (this.staffNoteEdits[k] || '').trim();

      try {
        row._savingNote = true;
        const db = getFirestore();
        const ref = doc(db, 'questionari', row.id);
        await updateDoc(ref, {
          staffNote: note || null,
          adminUpdatedAt: new Date().toISOString()
        });

        row.staffNote = note || '';
        this.saveStatus = { ...this.saveStatus, [k]: 'ok' };
      } catch (e) {
        console.error('saveStaffNote error:', e);
        this.saveStatus = { ...this.saveStatus, [k]: 'err' };
        alert('Errore nel salvataggio della nota interna.');
      } finally {
        row._savingNote = false;
      }
    },

    openAnswers(row) {
      this.activeRow = row;
      this.modalSearch = '';
      this.modalBundle = null;
      this.modalBundleError = '';
      this.showModal = true;
      this.prepareModalBundle(row);
    },

    handleQuestionarioClick(row) {
      if (!this.openQuestionarioPage(row)) {
        this.openAnswers(row);
      }
    },

    questionarioLinkLabel(row) {
      const target = this.resolveQuestionarioPath(row);
      if (target === 'check-finale') return 'Apri check finale';
      if (target === 'questionario') return 'Apri questionario';
      return 'Apri risposte';
    },

    resolveQuestionarioPath(row) {
      if (!row) return null;
      const typeKey = (row.type || '').toLowerCase();
      const stepKey = (row.stepKey || '').toLowerCase();
      if (typeKey === 'user_programmi_check_finale' || stepKey === 'check_finale') {
        return 'check-finale';
      }
      if (typeKey === 'user_programmi_questionario' || stepKey === 'questionario') {
        return 'questionario';
      }
      return null;
    },

    resolveQuestionarioRouteName(row) {
      const target = this.resolveQuestionarioPath(row);
      if (target === 'check-finale') return 'UserProgrammiCheckFinale';
      if (target === 'questionario') return 'UserProgrammiQuestionario';
      return null;
    },

    buildQuestionarioQuery(row) {
      const query = {};
      if (!row) return query;
      const assign = (key, value) => {
        if (value === undefined || value === null) return;
        const str = typeof value === 'string' ? value.trim() : String(value);
        if (str) query[key] = str;
      };
      assign('percorsoId', row.percorsoId);
      assign('stepIndex', row.stepIndex);
      assign('stepKey', row.stepKey);
      assign('sequenceGroupId', row.sequenceGroupId);
      assign('sequenceIndex', row.sequenceIndex);
      assign('sequenceTotal', row.sequenceTotal);
      assign('productId', row.productId);
      assign('productName', row.productName);
      assign('programTitle', row.programTitle || row.programLabel);
      assign('programLabel', row.programLabel || row.programTitle);
      assign('plannedStartAt', row.plannedStartAt);
      assign('expireAt', row.expireAt);
      assign('stepName', row.stepName);
      assign('questionarioDocId', row.id);
      if (row.manualStandalone || this.isManualQuestionarioPayload(row)) {
        assign('manualStandalone', '1');
      }
      return query;
    },

    stringifyQueryParams(query) {
      const entries = Object.entries(query || {}).filter(([, value]) => value !== undefined && value !== null && value !== '');
      if (!entries.length) return '';
      if (typeof URLSearchParams !== 'undefined') {
        const usp = new URLSearchParams();
        entries.forEach(([key, value]) => usp.append(key, value));
        return usp.toString();
      }
      return entries.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
    },

    openQuestionarioPage(row) {
      if (typeof window === 'undefined') return false;
      if (!row || !row.uid) return false;
      const routeName = this.resolveQuestionarioRouteName(row);
      const query = this.buildQuestionarioQuery(row);
      let href = '';

      if (routeName && this.$router && typeof this.$router.resolve === 'function') {
        const location = this.$router.resolve({
          name: routeName,
          params: { userId: row.uid },
          query,
        });
        href = location?.href || '';
      }

      if (!href) {
        const targetPath = this.resolveQuestionarioPath(row);
        if (!targetPath) return false;
        const queryString = this.stringifyQueryParams(query);
        href = `#/user/${row.uid}/programmi/${targetPath}${queryString ? `?${queryString}` : ''}`;
      }

      let targetHref = href;
      if (!/^https?:/i.test(targetHref || '')) {
        if (targetHref.startsWith('/#/')) {
          targetHref = targetHref.substring(1);
        } else if (targetHref.startsWith('/')) {
          targetHref = `#${targetHref}`;
        } else if (!targetHref.startsWith('#')) {
          targetHref = `#/${targetHref.replace(/^#?/, '')}`;
        }
      }
      window.open(targetHref, '_blank', 'noopener');
      return true;
    },

    closeModal() {
      this.showModal = false;
      this.activeRow = null;
      this.modalSearch = '';
      this.modalBundle = null;
      this.modalBundleError = '';
      this.modalLoading = false;
    },

    async prepareModalBundle(row) {
      if (!row || !row.uid) {
        this.modalBundle = { questionario: null, checkFinale: null };
        this.modalBundleError = row ? 'Utente non disponibile.' : '';
        this.modalLoading = false;
        return;
      }

      const cacheKey = row.uid ? `${row.uid}__manual` : row.id;
      if (this.bundleCache[cacheKey]) {
        this.modalBundle = this.bundleCache[cacheKey];
        return;
      }

      this.modalLoading = true;
      this.modalBundleError = '';

      try {
        const db = getFirestore();
        const constraints = [where('uid', '==', row.uid), where('percorsoId', '==', null)];
        let snap;
        try {
          snap = await getDocs(query(collection(db, 'questionari'), ...constraints));
        } catch (err) {
          // Fallback: alcune installazioni potrebbero richiedere un indice composito.
          snap = await getDocs(query(collection(db, 'questionari'), where('uid', '==', row.uid)));
        }
        const bundle = { questionario: null, checkFinale: null };

        const assignIfNewer = (targetKey, payload) => {
          const current = bundle[targetKey];
          if (!current) {
            bundle[targetKey] = payload;
            return;
          }
          const currentTime = (current.updatedAt || current.createdAt || new Date(0)).getTime();
          const nextTime = (payload.updatedAt || payload.createdAt || new Date(0)).getTime();
          if (nextTime >= currentTime) {
            bundle[targetKey] = payload;
          }
        };

        snap.forEach((docSnap) => {
          const data = docSnap.data() || {};
          if (!this.isManualQuestionarioPayload(data)) return;
          const base = {
            docId: docSnap.id,
            answers: data.answers || {},
            templateLabel:
              data.templateLabel ||
              data.questionarioTemplateLabel ||
              data.questionarioTemplate ||
              '',
            createdAt: toDateSafe(data.createdAt || data.created_at || null),
            updatedAt: toDateSafe(data.updatedAt || data.updated_at || data.createdAt || null),
            stepKey: data.stepKey || null,
            type: data.type || null,
          };

          const typeKey = (base.type || '').toLowerCase();
          const stepKey = (base.stepKey || '').toLowerCase();

          if (typeKey === 'user_programmi_questionario' || stepKey === 'questionario') {
            assignIfNewer('questionario', base);
          } else if (typeKey === 'user_programmi_check_finale' || stepKey === 'check_finale') {
            assignIfNewer('checkFinale', base);
          }
        });

        this.bundleCache = { ...this.bundleCache, [cacheKey]: bundle };
        this.modalBundle = bundle;
      } catch (error) {
        console.error('Errore caricando i questionari correlati:', error);
        this.modalBundleError = 'Impossibile recuperare tutti i dati salvati.';
        this.modalBundle = { questionario: null, checkFinale: null };
      } finally {
        this.modalLoading = false;
      }
    },

    gotoUser(uid) {
      if (!uid) return;
      window.open(`#/user/${uid}/anagrafica`, '_blank');
    },

    adminLabel(s) {
      const v = s || 'none';
      if (v === 'approved') return 'Approvato';
      if (v === 'needs_update') return 'Richiesto aggiornamento';
      if (v === 'updated') return 'Aggiornato';
      return '—';
    },
    adminChipClass(s) {
      const v = s || 'none';
      return {
        'chip-green': v === 'approved',
        'chip-orange': v === 'needs_update',
        'chip-blue': v === 'updated',
        'chip-neutral': v === 'none'
      };
    },

    stepCloneLabel(row) {
      if (!row) return '';
      const key = (row.stepKey || '').toLowerCase();
      if (key !== 'questionario') return '';
      const label = (row.templateLabel || '').trim();
      if (label) return label;
      const tplKey = (row.templateKey || '').toLowerCase();
      if (tplKey === 'check_finale') return 'check';
      return '';
    },

    sectionTitle(row) {
      if (!row) return 'Dettagli';
      const key = (row.stepKey || '').toLowerCase();
      if (key === 'questionario') return 'Questionario Programmi';
      if (key === 'check_finale') return 'Check Finale Programmi';
      if (key === 'feedback_programmi') return 'Feedback Programmi';
      if (key === 'consegna') return 'Consegna';
      return prettifyKey(key || 'Dettagli');
    },

    sectionSubtitle(row) {
      if (!row) return '';
      return row.templateLabel || row.templateKey || row.templateId || '';
    },

    formatDateTime(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.toLocaleString('it-IT', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
    },

    formatDateOnly(d) {
      if (!d) return '';
      const dt = new Date(d);
      return dt.toLocaleDateString('it-IT', { day:'2-digit', month:'2-digit', year:'numeric' });
    },

    normalizeExportValue(value) {
      if (value == null) return value;
      if (value instanceof Date) return value.toISOString();
      if (typeof value?.toDate === 'function') {
        try {
          return value.toDate().toISOString();
        } catch {
          return '';
        }
      }
      if (Array.isArray(value)) {
        return value.map((item) => this.normalizeExportValue(item));
      }
      if (typeof value === 'object') {
        const out = {};
        Object.entries(value).forEach(([key, val]) => {
          out[key] = this.normalizeExportValue(val);
        });
        return out;
      }
      return value;
    },

    formatExportValue(value) {
      const normalized = this.normalizeExportValue(value);
      if (normalized == null) return '';
      if (typeof normalized === 'object') return JSON.stringify(normalized);
      return String(normalized);
    },

    escapeCsvValue(value, separator = ';') {
      let str = value == null ? '' : String(value);
      if (str.includes('"')) {
        str = str.replace(/"/g, '""');
      }
      if (str.includes(separator) || str.includes('\n') || str.includes('\r') || str.includes('"')) {
        return `"${str}"`;
      }
      return str;
    },

    exportCsv() {
      try {
        const rows = this.savedQuestionari || [];
        if (!rows.length) {
          alert('Nessun questionario manuale da esportare.');
          return;
        }

        const separator = ';';
        const headers = [
          '#',
          'Stato admin',
          'Note',
          'Data',
          'Utente (email)',
          'Acquisto',
          'Ultimo acquisto',
          'Data acquisto',
          'Studio',
          'Step',
        ];

        const csvLines = [headers.join(separator)];
        rows.forEach((row, index) => {
          const statusLabel = this.adminLabel(row.adminStatus);
          const adminNote = (row.adminNote || '').toString().trim();
          const statusValue = adminNote ? `${statusLabel} | Nota: ${adminNote}` : statusLabel;
          const noteKey = this.keyFor(row);
          const staffNote =
            this.staffNoteEdits[noteKey] != null ? this.staffNoteEdits[noteKey] : (row.staffNote || '');
          const createdAt = this.formatDateTime(row.createdAt);
          const email = this.userEmails[row.uid] || '—';
          const purchase = this.purchaseChipLabel(row.uid);
          const lastProduct = this.latestOrderProductLabel(row.uid);
          const lastDate = this.latestOrderDateLabel(row.uid);
          const studio = this.userStudios[row.uid] || '—';
          const stepBase = row.stepKey || '—';
          const cloneLabel = this.stepCloneLabel(row);
          const stepDisplay = cloneLabel ? `${stepBase} · ${cloneLabel}` : stepBase;

          const values = [
            index + 1,
            statusValue,
            staffNote,
            createdAt,
            email,
            purchase,
            lastProduct,
            lastDate,
            studio,
            stepDisplay,
          ];

          csvLines.push(
            values
              .map((value) => this.escapeCsvValue(this.formatExportValue(value), separator))
              .join(separator)
          );
        });

        const blob = new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const date = new Date().toISOString().slice(0, 10);
        link.download = `questionari_manuali_${date}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Export CSV questionari manuali:', error);
        alert('Errore durante l\'esportazione CSV.');
      }
    },
  }
};
</script>

<style scoped>
.fb-red    { background-color: #fee2e2; }
.fb-orange { background-color: #fef3c7; }
.fb-green  { background-color: #dcfce7; }

.note-input {
  width: 100%;
  min-width: 140px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #111;
}

.profile-button { background: none; border: none; cursor: pointer; }
.icon-btn,
.stop-btn {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  width:36px;
  height:36px;
  padding:0;
  border-radius:10px;
  border:1px solid transparent;
  color:#fff;
  font-size:0.9rem;
  cursor:pointer;
  transition:transform 0.18s ease, box-shadow 0.18s ease;
}
.icon-btn .material-icons,
.stop-btn .material-icons { font-size:20px; }
.icon-btn:disabled,
.stop-btn:disabled { opacity:.65; cursor: not-allowed; box-shadow:none; transform:none; }
.icon-btn:hover:not(:disabled),
.stop-btn:hover:not(:disabled) {
  transform:translateY(-1px);
  box-shadow:0 6px 16px rgba(15, 23, 42, 0.12);
}
.stop-btn {
  background:#dc2626;
  border:1px solid #dc2626;
}

.filters { display:flex; gap:8px; flex-wrap:wrap; align-items:center; margin:8px 0; }
.text-input { padding:10px 12px; border:1px solid #dcdcdc; border-radius:10px; max-width: 167px; }
.text-input.small { padding:8px 10px; }
.btn { padding:8px 12px; border:1px solid #dcdcdc; border-radius:10px; background:#616161; cursor:pointer; color:#fff; }
.btn.tiny { padding:6px 10px; font-size:.85rem; color:#111; background:#e5e7eb; border-color:#e5e7eb; }

.tickets { overflow-x:auto; }
table { width:100%; min-width:1970px; border-collapse:collapse; table-layout:fixed; }
th, td { padding:8px 12px; text-align:left; border-bottom:1px solid #eee; vertical-align:top; white-space:normal; }
thead th { background:#f7f7f7; }

.col-idx{ width:60px; }
.col-azione{ width:160px; }
.col-admin{ width:220px; }
.col-note{ width:260px; }
.col-data{ width:160px; }
.col-email{ width:260px; }
.col-acquisto-flag{ width:110px; }
.col-acquisto{ width:220px; }
.col-acquisto-data{ width:160px; }
.col-studio{ width:200px; }
.col-step{ width:160px; }

.muted{ color:#6b7280; }

.step-cell { display:flex; align-items:center; gap:6px; flex-wrap:wrap; }
.step-tag {
  display:inline-flex;
  align-items:center;
  gap:4px;
  font-size:0.78rem;
  color:#475569;
  background:#eef2ff;
  border-radius:999px;
  padding:2px 8px;
  border:1px solid #c7d2fe;
}

.admin-col { min-width: 220px; }
.admin-chip {
  display:inline-block; padding:3px 8px; border-radius:999px;
  border: 1px solid #e5e7eb; font-size: .78rem; line-height: 1.25rem;
  background:#f3f4f6; color:#374151;
}
.chip-neutral { background:#f3f4f6; }
.chip-green   { background:#dcfce7; color:#065f46; border-color:#bbf7d0; }
.chip-orange  { background:#fff7ed; color:#9a3412; border-color:#fed7aa; }
.chip-blue    { background:#dbeafe; color:#1d4ed8; border-color:#bfdbfe; }
.chips-line { display:flex; gap:6px; flex-wrap:wrap; align-items:center; }

.purchase-chip {
  display:inline-flex;
  align-items:center;
  justify-content:center;
  min-width:46px;
  padding:2px 8px;
  border-radius:999px;
  border:1px solid #e5e7eb;
  font-size:.78rem;
  line-height:1.25rem;
  background:#f3f4f6;
  color:#374151;
}
.purchase-chip--yes { background:#dcfce7; color:#065f46; border-color:#bbf7d0; }
.purchase-chip--no { background:#fee2e2; color:#991b1b; border-color:#fecaca; }
.purchase-chip--pending { background:#fef3c7; color:#92400e; border-color:#fde68a; }
.purchase-chip--muted { background:#f3f4f6; color:#6b7280; }
.purchase-product--coaching {
  color:#2563eb;
  font-weight:600;
}

.modal .dialog { background:#fff; width:min(1007px,94vw); height:min(95vh, 860px); border-radius:14px; box-shadow:0 24px 60px rgba(0,0,0,.25); padding:18px; display:flex; flex-direction:column; }
.modal-head { display:flex; justify-content:space-between; align-items:center; gap:10px; margin-bottom:8px; }
.meta { display:grid; grid-template-columns: repeat(auto-fit,minmax(240px,1fr)); gap:8px; margin-bottom:10px; }
.meta-step { display:flex; align-items:center; gap:6px; flex-wrap:wrap; }

.modal-scroll { flex:1; overflow:auto; padding-right:8px; }

.answers { display:grid; gap:12px; }
.data-state {
  padding: 14px;
  border: 1px dashed #d1d5db;
  border-radius: 12px;
  font-size: 0.92rem;
  color: #1f2937;
  text-align: center;
}
.data-state.error {
  color: #b91c1c;
  border-color: rgba(185, 28, 28, 0.35);
  background: rgba(248, 113, 113, 0.08);
}

.modal-sections {
  display: grid;
  gap: 18px;
}

.modal-section {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.modal-section__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.modal-section__head h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.modal-section__subtitle {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: #475569;
}

.modal-section__meta {
  font-size: 0.82rem;
  color: #1f2937;
  font-weight: 500;
}

.modal-section__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.modal-group__title {
  margin: 0;
  font-size: 0.88rem;
  font-weight: 600;
  color: #1d4ed8;
  text-transform: capitalize;
}

.modal-row {
  display: grid;
  grid-template-columns: minmax(150px, 220px) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.modal-row.multiline {
  align-items: stretch;
}

.modal-row__key {
  font-size: 0.86rem;
  font-weight: 600;
  color: #1f2937;
  word-break: break-word;
}

.modal-row__value {
  font-size: 0.86rem;
  color: #0f172a;
  word-break: break-word;
}

.modal-row__value pre {
  margin: 0;
  font-size: 0.82rem;
  background: none;
  white-space: pre-wrap;
  font-family: 'SFMono-Regular', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
}
</style>
